<template>
  <div :class="{ uWhite: isTablet || isMobile }">
    <a v-if="referrerCheck" class="c-bannerFixed js-banner" :href="`/kodate/${validateKindPath(propData.kind)}area/${storedLocation.pref.code}/${storedLocation.city.code}/`">
      {{storedLocation.city.name}}にある、その他{{validateKind(propData.kind)}}はこちらからご覧いただけます。
      <img width="28" height="28" src="@/assets/arrow-circle.png" alt="">
    </a>

    <common-img-modal
      v-if="isModalList  && propPhotos.length  > 0"
      :propPhotos="propPhotos"
      :isModalList="isModalList"
      :propName="propName"
      :detailIndex="detailIndex"
      @input="isModalList = $event"
    />

    <div class="c-contentWrap">
      <h3 class="c-pageTitle">
        <span class="c-pageTitle__label">{{validateKind(propKind)}}</span>
        <span class="c-pageTitle__name">{{validateText(propName)}}</span>
      </h3>
      <div class="c-slider">
        <div class="c-slider__main">
          <img class="c-slider__item c-slider__item__img js-slider" width="375" height="260" :src="imageRender(propMainViewImgUrl,propData.priority, mode)" alt="">
          <school-area-google-map class="c-slider__item" :center="coordinate" :makerList="markers" :zoom="zoom" />

          <span class="c-slider__arrow c-slider__arrow--prev" @click="onClickSlider(slider)"></span>
          <span class="c-slider__arrow c-slider__arrow--next" @click="onClickSlider(slider)"></span>
        </div>

        <div class="c-slider__thumbnail">
          <div class="c-slider__thumbnailItem" :class="{'c-slider__thumbnailItem--active': slider}" @click="onClickSlider(false)">
            <img class="c-slider__thumbnailImage" :src="imageRender(propMainViewImgUrl, propData.priority)" alt="">
          </div>
          <div class="c-slider__thumbnailItem" :class="{'c-slider__thumbnailItem--active': !slider}" @click="onClickSlider(true)">
            <img class="c-slider__thumbnailImage" src="@/assets/images/sample-map.png" alt="">
          </div>
        </div>
      </div>
      <p class="c-attention u-dSP">※地図上に表示されているマークは、物件がその付近住所に所在することを表すものであり、実際の物件所在地とは異なる場合があります。</p>

      <div class="c-contentSpWrap">
        <h2 class="c-detailInfoTitle u-dSP" v-if="this.extraPropData.c232">
          {{this.extraPropData.c131}}
        </h2>

        <div class="c-info">
          <div class="c-info__content">
            <div class="c-info__item">
              <span class="c-info__head">所在地</span>
              <p class="c-info__data">{{validateText(propAddress)}}</p>
            </div>
            <div class="c-info__item">
              <span class="c-info__head c-info__head__access">交通</span>
              <p class="c-info__data c-info__data__access">{{validateText(propAccess)}}</p>
            </div>
            <div class="c-info__item">
              <span class="c-info__head">価格</span>
              <p class="c-info__data c-info__data--big">{{validateText(propPrice)}}</p>
            </div>
            <div class="c-info__item">
              <span class="c-info__head c-info__head__area">土地面積</span>
              <p class="c-info__data c-info__data__area">
                <common-area-changer
                  :val="validateText(propSikichi)"
                  :size="13"
                />
              </p>
            </div>
            <div class="c-info__item">
              <span class="c-info__head c-info__head__area">建物面積</span>
              <p class="c-info__data c-info__data__area">
                <common-area-changer
                  :val="validateText(propTatemono)"
                  :size="13"
                />
              </p>
            </div>
            <div class="c-info__item">
              <span class="c-info__head c-info__head__layout">間取り</span>
              <p class="c-info__data c-info__data__layout">{{validateText(propLayout)}}</p>
            </div>
          </div>

          <div class="c-info__action">
            <div>
              <div class="c-info__actionButtonWrap">
                <common-button
                  v-if="propData.priority > 1 && this.propData.contact_tel"
                  :title="propPhone"
                  :type="'link'"
                  :link_url="`tel:${propPhone}`"
                  :large="true"
                  :width="'100%'"
                  :border_red_text_black="true"
                  :color_red_text="true"
                  :font_size="'14px'"
                  :icon="'icon_phone_call'" />
                <common-button
                  v-if="propData.priority > 1"
                  :title="'資料請求する'"
                  :type="'link'"
                  :link_url="`/document-request/${propData.id}`"
                  :large="true"
                  :width="'100%'"
                  :border_red_text_black="true"
                  :color_red_text="true"
                  :font_size="'14px'"
                  :icon="'icon-mail'"
                  :label="'無料'" />
                <common-button
                  :title="'見学予約する'"
                  :type="'link'"
                  :link_url="`/reservation/${propData.id}`"
                  :large="true"
                  :width="'100%'"
                  :border_red_text_black="true"
                  :color_red_text="true"
                  :font_size="'14px'"
                  :icon="'icon-calendar-red'"
                  :label="'無料'" />
                <img
                  v-if="isBalloon"
                  class="c-buttonFav--balloon"
                  :src="require('@/assets/images/balloon/fav.png')"
                />
                <common-button
                    v-if="!isAdded"
                    :title="'お気に入りに追加'"
                    :link_url="`/reservation/${propData.id}`"
                    :large="true"
                    :width="'100%'"
                    :font_size="'14px'"
                    :callback="toggleFavorite"
                    :attr=[]
                    :border_red_text_black="true"
                    :color_red_text="true"
                    :icon="'icon-favorite'" />
                <common-button
                  v-else
                  :title="'お気に入りに済み'"
                  :link_url="`/reservation/${propData.id}`"
                  :large="true"
                  :width="'100%'"
                  :border_red_text_black="true"
                  :color_red_text="true"
                  :font_size="'14px'"
                  :callback="toggleFavorite"
                  :attr=[]
                  :icon="'favorite-selected'" />
                <common-button
                  v-if="!this.propData.contact_tel"
                  class="u-mB10"
                  :title="'掲載元のページに移動'"
                  :type="'link'"
                  :link_url="propData.url"
                  :large="true"
                  :width="'100%'"
                  :tablet_width="true"
                  :font_size="'14px'"
                  :icon="'icon-external-link-grey'"
                  :target_blank="true" />
              </div>
            </div>
            <div class="c-info__date">
              <p class="c-info__dateText">情報提供日：{{validateDate(propProvidedAt,'YYYY年MM月DD日')}}</p>
              <p class="c-info__dateText">次回更新日：{{validateText(propModifyAt)}}</p>
            </div>
          </div>
        </div>

        <div class="c-imageArea">
          <div class="c-imageArea__item">
            <img class="c-imageArea__img" width="440" height="330" :src="imageRender(propMainViewImgUrl, propData.priority, mode)" alt="">
            <p class="c-imageArea__text" v-if="this.extraPropData.c232">{{this.extraPropData.c232}}</p>
          </div>
          <div class="c-imageArea__item">
            <school-area-google-map class="c-imageArea__img" width="440" height="330" :center="coordinate" :makerList="markers" :zoom="zoom" />
            <p class="c-attention u-dPC">※地図上に表示されているマークは、物件がその付近住所に所在することを表すものであり、実際の物件所在地とは異なる場合があります。</p>
          </div>
        </div>
        <section class="c-section c-section--detailInfo">
          <h3 class="c-detailInfoTitle u-dPC" v-if="this.extraPropData.c131">
            {{this.extraPropData.c131}}
          </h3>
          <div class="c-detailInfoText" v-if="this.extraPropData.facility_out">
            <p class="c-detailInfoText__text">
              {{this.extraPropData.facility_out}}
            </p>
            <span class="c-detailInfoText__more">
              もっと見る
              <img class="c-detailInfoText__moreImg" src="@/assets/images/icon-circle-arrow.png" alt="">
            </span>
          </div>
        </section>
      </div>
    </div>

    <section class="c-section">
      <h3 class="c-heading u-mB16" v-if="propPhotos.length > 0">
        写真一覧
        <a class="c-heading__more" @click="modalListOpen">
          一覧で見る
          <img class="c-heading__moreImg" src="@/assets/images/icon-circle-arrow.png" alt="">
        </a>
      </h3>
      <ul class="c-imgList" v-if="propPhotos.length > 0">
        <li class="c-imgList__item" v-for="(item, index) in propPhotos" :key="index">
          <a class="c-imgList__link" @click="isModalList = !isModalList; detailIndex = index">
            <div class="c-imgList__imgWrap">
              <img class="c-imgList__img" :src="item.img" alt="">
              <img class="c-imgList__icon" src="@/assets/images/search-white.png" alt="">
            </div>
            <span class="c-imgList__title">{{item.text}}</span>
          </a>
        </li>
      </ul>

      <!-- <ul class="c-list">
        <li class="c-list__item">
          <h4 class="c-list__title">徒歩5分以内</h4>
          <ul class="c-list__childList">
            <li class="c-list__childItem">
              <h5 class="c-list__childTitle">コンビニ</h5>
              <p class="c-list__childText">セブンイレブン~~町 110m</p>
            </li>
            <li class="c-list__childItem">
              <h5 class="c-list__childTitle">コンビニ</h5>
              <p class="c-list__childText">セブンイレブン~~町 110m</p>
            </li>
          </ul>
        </li>
        <li class="c-list__item">
          <h4 class="c-list__title">徒歩10分以内</h4>
          <ul class="c-list__childList">
            <li class="c-list__childItem">
              <h5 class="c-list__childTitle">コンビニ</h5>
              <p class="c-list__childText">セブンイレブン~~町 110m</p>
            </li>
            <li class="c-list__childItem">
              <h5 class="c-list__childTitle">郵便局</h5>
              <p class="c-list__childText">セブンイレブン~~町 110m</p>
            </li>
          </ul>
        </li>
        <li class="c-list__item">
          <h4 class="c-list__title">徒歩15分以内</h4>
          <ul class="c-list__childList">
            <li class="c-list__childItem">
              <h5 class="c-list__childTitle">スーパー</h5>
              <p class="c-list__childText">セブンイレブン~~町 110m</p>
            </li>
            <li class="c-list__childItem">
              <h5 class="c-list__childTitle">コンビニ</h5>
              <p class="c-list__childText">セブンイレブン~~町 110m</p>
            </li>
          </ul>
        </li>
        <li class="c-list__item">
          <h4 class="c-list__title">その他周辺環境</h4>
          <ul class="c-list__childList">
            <li class="c-list__childItem">
              <h5 class="c-list__childTitle">コンビニ</h5>
              <p class="c-list__childText">セブンイレブン~~町 110m</p>
            </li>
            <li class="c-list__childItem">
              <h5 class="c-list__childTitle">コンビニ</h5>
              <p class="c-list__childText">セブンイレブン~~町 110m</p>
            </li>
          </ul>
        </li>
      </ul>-->
    </section>
    <section v-if="storedLocation" class="c-section u-mT50">
      <h3 class="c-heading u-mB16">同じ市区郡の{{validateKind(propKind)}}を見る</h3>
      <a :href="`/kodate/${validateKindPath(propKind)}area/${storedLocation.pref.code}/${storedLocation.city.code}/`">{{storedLocation.city.name}}</a>
    </section>
    <section v-if="storedLocation" class="c-section">
      <h3 class="c-heading u-mB16">同じ都県の{{validateKind(propKind)}}を見る</h3>
      <a :href="`/kodate/${validateKindPath(propKind)}area/${storedLocation.pref.code}/`">{{storedLocation.pref.name}}</a>
    </section>
    <section class="c-section">
      <h3 class="c-heading u-mB16">物件詳細</h3>
      <dl class="c-table">
        <dt class="c-table__head">物件名</dt>
        <dd class="c-table__data">{{validateText(propName)}}</dd>
        <dt class="c-table__head">用途地域</dt>
        <dd class="c-table__data">{{validateText(propRegulation)}}</dd>
        <dt class="c-table__head">価格</dt>
        <dd class="c-table__data">{{validateText(propPrice)}}</dd>
        <dt class="c-table__head">現況</dt>
        <dd class="c-table__data">{{validateKind(propKind)}}</dd>
        <dt class="c-table__head">販売戸数</dt>
        <dd class="c-table__data">{{validateText(propAmount)}}</dd>
        <dt class="c-table__head">土地権利</dt>
        <dd class="c-table__data">{{validateText(propTitle)}}</dd>
        <dt class="c-table__head">交通</dt>
        <dd class="c-table__data">
          <p  v-for="(item, index) in propData.access" :key="index">{{item.name}}</p>
        </dd>
        <dt class="c-table__head">取引態様</dt>
        <dd class="c-table__data">{{validateText(propContactType)}}</dd>
        <dt class="c-table__head">私道負担</dt>
        <dd class="c-table__data">{{validateText(propDriveWay)}}</dd>
        <dt class="c-table__head">接道・道路幅員</dt>
        <dd class="c-table__data">{{validateText(propAdjacentRoadStatus)}}</dd>
        <!-- <dt class="c-table__head">建築確認番号</dt>
        <dd class="c-table__data">{{validateText(extraPropData.kkakunin)}}</dd> -->
        <dt class="c-table__head">建ぺい率・容積率</dt>
        <dd class="c-table__data">{{validateText(propRatio)}}</dd>
        <dt class="c-table__head">完成時期</dt>
        <dd class="c-table__data">{{validateText(propBuiltAtWithin)}}</dd>
        <dt class="c-table__head">構造・工法</dt>
        <dd class="c-table__data">{{validateText(propBuildingMethod)}}</dd>
        <!-- <dt class="c-table__head">地目</dt>
        <dd class="c-table__data">{{validateText(extraPropData.timoku)}}</dd> -->
        <dt class="c-table__head">間取り/間取り詳細</dt>
        <dd class="c-table__data">{{validateText(propLayout)}}</dd>
        <dt class="c-table__head">情報提供日</dt>
        <dd class="c-table__data">{{validateDate(propProvidedAt,'YYYY年MM月DD日')}}</dd>
        <dt class="c-table__head">土地面積</dt>
        <dd class="c-table__data">
          <common-area-changer
            :val="validateText(propSikichi)"
            :size="13"
          />
        </dd>
        <dt class="c-table__head">次回更新日</dt>
        <dd class="c-table__data">{{validateText(propModifyAt)}}</dd>
        <dt class="c-table__head">建物面積</dt>
        <dd class="c-table__data">
          <common-area-changer
            :val="validateText(propTatemono)"
            :size="13"
          />
        </dd>
        <dt class="c-table__head">その他制限事項</dt>
        <dd class="c-table__data">{{validateText(propRestriction)}}</dd>
        <dt class="c-table__head">その他概要・特記事項</dt>
        <dd class="c-table__data">{{validateText(propNote)}}</dd>
        <!-- <dt class="c-table__head"></dt>
        <dd class="c-table__data"></dd> -->
      </dl>
    </section>

    <section class="c-section">
      <h3 class="c-heading u-mB16">会社情報</h3>
      <p class="c-text">{{validateText(propContactName)}}</p>
      <p class="c-text">TEL : {{validateText(propPhone)}}</p>
      <p class="c-text">{{validateText(propContactLicense)}}</p>
      <p class="c-text">{{validateText(propContactAddress)}}</p>
      <p v-if="propData.contact_organization !== undefined" class="c-text">{{validateText(propData.contact_organization)}}</p>
    </section>
  </div>
</template>

<script>
import MixinUtil from '@/plugins/mixin-utils';
import isMobile from '@/plugins/isMobile';
import Meta from '@/plugins/mixin-meta';
import BehaviorLogMixin from '@/plugins/mixin-behavior-log';


import SchoolAreaGoogleMap from '@/components/parts/SchoolAreaGoogleMap';
import CommonAreaChanger from '@/components/parts/CommonAreaChanger';
import CommonButton from '@/components/parts/button/CommonButton';
import CommonImgModal from '@/components/parts/CommonImgModal';

import dayjs from 'dayjs';

dayjs.locale('ja');

const querystring = window.location.search;
const query = [...new URLSearchParams(querystring).entries()]
  .reduce((obj, e) => ({ ...obj, [e[0]]: e[1] }), {});

export default {
  name: 'KodateContentsNew',
  mixins: [MixinUtil, isMobile, Meta, BehaviorLogMixin],
  props: ['propData', 'extraPropData', 'referrerCheck'],
  components: {
    SchoolAreaGoogleMap,
    CommonAreaChanger,
    CommonButton,
    CommonImgModal,
  },
  data() {
    return {
      coordinate: null,
      locationObject: {},
      markers: [],
      slider: true,
      isBalloon: false,
      isReady: false,
      isMapReady: false,
      isAdded: false,
      zoom: 13,
      mode: 'prod',
      isModalList: false,
      detailIndex: null,
    };
  },
  computed: {
    storedFavorite() {
      return this.$store.getters['getFavorite'];
    },
    storedLocation() {
      return this.$store.getters['getLocation'];
    },
    layout() {
      return this.propData.layout.replace(',', '〜');
    },
    propMainViewImgUrl() {
      return this.extraPropData.c229 ? `https://homehouse.ki-group.jp/photo/${this.extraPropData.c229}` : this.propData.image;
    },
    propKind() {
      return this.propData.kind;
    },
    propName() {
      return this.propData.name;
    },
    propAddress() {
      return this.propData.address;
    },
    propAccess() {
      return this.propData.access[0].name;
    },
    propPrice() {
      return this.propData.price;
    },
    propSikichi() {
      return this.propData.land_area;
    },
    propTatemono() {
      return this.propData.building_area;
    },
    propLayout() {
      return this.propData.layout;
    },
    propPhone() {
      return this.propData.contact_tel ? this.propData.contact_tel : this.propData.contact_phone;
    },
    propProvidedAt() {
      return this.propData.provided_at;
    },
    propModifyAt() {
      // return this.propData.modifiy_at ? this.propData.modifiy_at : '情報提供より14日以内に更新';
      return '情報提供より14日以内に更新';
    },
    propPhotos() {
      const ret = [];
      for (let i = 225; i <= 365; i += 4) {
        if (i !== 229 && this.extraPropData[`c${i}`]) {
          ret.push({
            img: `https://homehouse.ki-group.jp/photo/${this.extraPropData[`c${i}`]}`,
            text: this.extraPropData[`c${i + 3}`],
          });
        }
      }
      return ret;
    },
    propRegulation() {
      return this.propData.regulation_of_area;
    },
    propAmount() {
      return this.propData.amount;
    },
    propTitle() {
      return this.propData.land_title;
    },
    propRestriction() {
      return this.propData.restriction;
    },
    propContactType() {
      return this.propData.contact_type;
    },
    propDriveWay() {
      return this.propData.driveway;
    },
    propRatio() {
      return this.propData.ratio;
    },
    propBuildingMethod() {
      return this.propData.building_method;
    },
    propBuiltAtWithin() {
      return this.propData.built_at_within;
    },
    propAdjacentRoadStatus() {
      return this.propData.adjacent_road_status;
    },
    propNote() {
      return this.propData.note;
    },
    propContactName() {
      return this.propData.contact_name;
    },
    propContactLicense() {
      return this.propData.contact_license;
    },
    propContactAddress() {
      return this.propData.contact_address;
    },

  },
  async mounted() {
    if (query.zoom !== undefined) this.zoom = parseInt(query.zoom, 10);
    if (query.mode !== undefined) this.mode = query.mode;
    this.metaSetForDetail(this.storedLocation.pref.name, this.storedLocation.city.name, this.propData);

    // 地図セット
    this.markers.push(
      { position:
        {
          lat: this.propData.location.latitude,
          lng: this.propData.location.longitude,
        },
      title: 'marker_1',
      },
    );
    this.coordinate = {
      lat: this.propData.location.latitude,
      lng: this.propData.location.longitude,
    };

    // fav
    this.list = this.storedFavorite.data;
    if (this.list === null) this.list = [];
    if (this.list.length > 0) this.isAdded = this.list.find(n => n.id.toString() === this.propData.id.toString()) !== undefined;

    // Footer表示フラグ更新
    await this.$store.commit('setFooterDisplayFlag');
    this.displayBanner();
  },
  methods: {
    validateText(v, esc = '-') {
      let ret;
      if (v) {
        ret = v;
      } else {
        ret = esc;
      }
      return ret;
    },
    validateDate(val) {
      return dayjs(val).format('YYYY年MM月DD日');
    },
    validateKind(v) {
      return v === 'newly-house' ? '新築一戸建て' : '中古一戸建て';
    },
    validateKindPath(v) {
      let ret = '';
      if (v === 'newly-house') {
        ret = 'shinchiku/';
      } else if (v === 'second-hand-house') {
        ret = 'chuko/';
      }
      return ret;
    },
    onClickSlider(direction) {
      if (direction) document.querySelector('.js-slider').style.marginLeft = '-100%';
      else document.querySelector('.js-slider').style.marginLeft = '0';
      this.slider = !this.slider;
    },
    toggleFavorite() {
      this.list = this.storedFavorite;
      if (this.list === null) this.list = [];
      if (!this.isAdded) {
        this.addWishList({
          id: this.propData.id,
          pageName: this.propData.name,
          oldPriceMin: +this.propData.price_min,
          oldPriceMax: +this.propData.price_max,
        });
        // this.list.unshift({
        //   ...this.propData,
        //   index: this.list.length > 0 ? this.list[0].index + 1 : 0,
        //   registered: new Date(),
        //   oldPriceMin: +this.propData.price_min,
        //   oldPrice: +this.propData.price,
        // });
        this.isAdded = true;
        this.isBalloon = true;
        setTimeout(() => {
          this.isBalloon = false;
        }, 3000);
      } else {
        this.isAdded = false;
        this.deleteWishList(this.propData.id);
      }
    },
    modalListOpen() {
      if (this.isModalList) {
        this.isModalList = false;
        document.body.style.position = 'unset';
        document.body.style.top = 'unset';
        document.body.style.bottom = 'unset';
        document.body.style.right = 'unset';
        document.body.style.left = 'unset';
      } else {
        this.isModalList = true;
        document.body.style.position = 'fixed';
        document.body.style.top = '0';
        document.body.style.bottom = '0';
        document.body.style.right = '0';
        document.body.style.left = '0';
      }
    },
    displayBanner() {
      const footer = document.querySelector('.js-footer');
      const banner = document.querySelector('.js-banner');
      const clientRect = footer.getBoundingClientRect();
      const offset = clientRect.top - window.innerHeight;

      window.addEventListener('scroll', () => {
        let timeID;
        if (timeID != null) clearTimeout(timeID);

        timeID = setTimeout(() => {
          if (window.pageYOffset >= offset) {
            banner.classList.add('c-bannerFixed--passive');
          } else {
            banner.classList.remove('c-bannerFixed--passive');
          }
          timeID = null;
        }, 200);
      });
    },
  },
};
</script>

<!-- Add 'scoped' attribute to limit CSS to this component only -->
<style scoped lang="scss">
@charset "UTF-8";
.u-dPC {
  display: block;
}
.u-dSP {
  display: none;
}

.u-button--fav {
    width: calc(50% - 10px);
    margin-right: 10px;
    margin-bottom: 10px;
}

.c-info {
  display: flex;
  justify-content: space-between;
  margin-top: 20px;

  &__content {
    width: calc(50% - 20px);
    margin-right: 20px;
  }
  &__action {
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    justify-content: space-between;
    width: 50%;
  }
  &__actionButtonWrap {
    display: flex;
    position: relative;
    flex-wrap: wrap;
    width: 100%;

    .c-button {
      width: calc(50% - 10px);
      margin-right: 10px;
      margin-bottom: 10px;
    }
  }
  &__balloon {
    position: absolute;
    width:237px;
    z-index:10;
    right: 0;
  }
  &__item {
    display: flex;
    align-items: center;
    margin-bottom: 20px;
    &:last-child {
      margin-bottom: 0;
    }
  }
  &__mobileButton {
    display: none;
  }
  &__smallItem {
    display: flex;
    align-items: center;
    margin-right: 20px;
    margin-bottom: 20px;

    &:last-child {
      margin-right: 0;
    }
  }
  &__head {
    padding: 8px 0;
    margin-right: 20px;
    border: 1px solid #cccccc;
    color: #666666;
    font-size: 14px;
    background: #fafafa;
    width: 88px;
    min-width: 88px;
    text-align: center;
  }
  &__data {
    color: #666666;
    font-size: 14px;
    line-height: 1.5;
    &__access {
      width:calc(100%  - 82px)
    }
    &__layout {
      width:calc(100%  - 96px)
    }
    &__area {
      width:calc(100%  - 110px)
    }

    &--big {
      font-size: 24px;
      font-weight: bold;
      color: #E83532;
    }
  }
  &__date {
    width: 100%;
    text-align: right;
  }
  &__dateText {
    font-size: 12px;
    color: #666666;
    line-height: 1.6;
  }
}
.u-mT10 {
  margin-top: 10px;
}

.c-buttonFav {
  display: inline-flex;
  justify-content: center;
  align-items: center;
  padding: 15px 34px;
  min-width: 228px;
  width: 100%;
  border: 1px solid #e83532;
  border-radius: 40px;
  color: #666666;
  font-size: 14px;
  word-break: keep-all;

  &--balloon {
    position:absolute;
    display:block;
    top: 0px;
    left: calc(50% - 35px);
    z-index: 111;
  }
  &--off {
    cursor: pointer;
    &:before {
      content: "";
      display: inline-block;
      width: 24px;
      height: 23px;
      margin-right: 10px;
      background-image: url(/static/img/favorite-selected.png);
      background-size: contain;
    }
  }
  &--on {
    background-color: #E83532;
    color: #FFF;
    cursor: pointer;
    &:before {
      content: "";
      display: inline-block;
      width: 24px;
      height: 23px;
      margin-right: 10px;
      background-image: url(/static/img/icon-favorite.png);
      background-size: contain;
    }
  }
}


.c-attention {
  margin: 9px;
  font-size: 12px;
  line-height: 1.5;
}
.c-pageTitle {
  display: flex;
  align-items: center;
  margin: 0;

  &__label {
    padding: 8px 16px;
    margin-right: 20px;
    color: #fff;
    font-size: 14px;
    background: #E83532;
    line-height: 1;
  }
  &__name {
    font-size: 18px;
    font-weight: bold;
    margin-right: 10px;
  }
}

.c-heading {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 13px 20px 15px;
  border-radius: 10px;
  color: #666666;
  font-size: 18px;
  font-weight: bold;
  background: #f6f6f6;

  &__more {
    display: flex;
    align-items: center;
    color: #E83532;
    font-size: 12px;
    line-height: 1.2;
  }
  &__moreImg {
    width: 20ox;
    height: 20px;
    margin-left: 6px;
  }
}

.c-section {
  margin: 30px 0 14px;

  &--detailInfo {
    margin: 80px 0 28px;
  }
}

.c-detailInfoTitle {
  font-size: 16px;
  font-weight: bold;
  line-height: 1.8;
  color: #666666;
  text-align: center;
}

.c-detailInfoText {
  padding: 10px;
  margin-top: 10px;
  background: #FAFAFA;

  &__text {
    font-size: 12px;
    color: #666666;
    line-height: 1.8;
  }
  &__more {
    display: none;
  }
}

.c-imgList {
  display: flex;
  flex-wrap: wrap;
  max-width: 776px;
  margin: 0 auto;

  &__item {
    width: calc((100% / 3) - 10px);
    border: 1px solid #CCCCCC;
    border-radius: 20px 20px 20px 0;
    margin-right: 10px;
    margin-bottom: 10px;

    &:last-child {
      margin-right: 0;
    }
  }
  &__imgWrap {
    position: relative;
  }
  &__img {
    width: 100%;
    height: 185px;
    object-fit: contain;
    border-radius: 20px 20px 0 0;
  }
  &__icon {
    position: absolute;
    bottom: 6px;
    right: 10px;
    width: 18px;
    height: 17px;
  }
  &__title {
    display: block;
    padding: 6px;
    font-size: 14px;
    color: #666666;
    line-height: 1.4;
  }
}

.c-imageArea {
  display: flex;
  justify-content: space-between;
  width: 100%;
  margin-top: 40px;

  &__item {
    width: calc(50% - 10px);
    height: 336px;
    object-fit: cover;
    margin-right: 20px;

    &:last-child {
      margin-right: 0;
    }
  }
  &__img {
    width: 100%;
    height: 337px;
    object-fit: cover;
  }
  &__text {
    font-size: 14px;
    line-height: 1.5;
  }
}

.c-table {
  display: flex;
  flex-wrap: wrap;
  border-right: 1px solid #cccccc;
  border-bottom: 1px solid #cccccc;

  &__head {
    width: 160px;
    padding: 8px 10px;
    background: #fafafa;
    border-top: 1px solid #cccccc;
    border-right: 1px solid #cccccc;
    border-left: 1px solid #cccccc;
    box-sizing: border-box;
    color: #666666;
    font-size: 13px;
  }
  &__data {
    width: calc(50% - 160px);
    padding: 8px 10px;
    border-top: 1px solid #cccccc;
    box-sizing: border-box;
    color: #666666;
    font-size: 13px;
    line-height: 1.6;
  }
}

.c-text {
  color: #666666;
  font-size: 14px;
  line-height: 1.7;
}

.c-slider {
  display: none;
}

.c-list {
  &__item {
    margin: 15px 0;
  }
  &__title {
    padding: 10px 0;
    border-bottom: 1px solid #CCCCCC;
    font-size: 14px;
    font-weight: bold;
    color: #666666;
    line-height: 1.2;

    &:before {
      content: "";
      display: inline-block;
      width: 8px;
      height: 8px;
      margin-right: 12px;
      background: #E83532;
      border-radius: 50%;
    }
  }
  &__childList {
    margin-top: 13px;
    margin-left: 20px;
  }
  &__childItem {
    margin-bottom: 15px;
  }
  &__childTitle {
    margin-bottom: 4px;
    font-size: 14px;
    font-weight: bold;
    color: #666666;
    line-height: 1.2;
  }
  &__childText {
    font-size: 14px;
    color: #666666;
    line-height: 1.2;
  }
}

.c-bannerFixed {
  display: flex;
  align-items: center;
  justify-content: center;
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  padding: 22px 0;
  background: #FAFAFA;
  text-align: center;
  z-index: 100;
  transition: all 0.2s ease-out;

  &--passive {
    opacity: 0;
    transform: translateY(100%);
  }
}


.u-mT10 {
  margin-top: 10px;
}
.u-mT50 {
  margin-top: 50px;
}
.u-mB10 {
  margin-bottom: 10px;
}
.u-mB16 {
  margin-bottom: 16px;
}

@media screen and (max-width: 999px) {
  .u-dPC {
    display: none;
  }
  .u-dSP {
    display: block;
  }
  .c-detailInfoTitle {
    margin: 20px 0;
  }
  .c-buttonFav.u-mT10 {
    margin-top: 0;
  }
  .c-buttonFav--balloon {
      top: 132px;
      left: calc(50% - 145px);
   }
  .c-pageTitle {
    margin: 30px 10px;
    &__name {
      margin-top: 20px;
    }
  }
  .c-slider {
    display: block;
    margin-bottom: 20px;

    &__main {
      display: flex;
      align-items: center;
      overflow: scroll;
      position: relative;
    }
    &__arrow {
      position: absolute;
      top: 50%;
      width: 36px;
      height: 36px;
      border: 1px solid #cccccc;
      border-radius: 50%;
      background:rgba(255,255,255,0.8);
      // transform: translateY(-50%);

      &:before, &:after {
        position: absolute;
        top: calc(50% - 9px);
        left: calc(50% - 8px);
        content: "";
        display: inline-block;
        width: 18px;
        height: 18px;
        background-image: url(/static/img/icon-arrow.png);
        background-size: contain;

      }
      &--prev {
        left: 10px;
        transform: rotate(180deg);
      }
      &--next {
        right: 10px;
      }
    }
    &__item {
      width: 100vh;
      object-fit: cover;
      &__img {
        min-width: 100%;
        height: 100%;
      }
    }
    &__thumbnail {
      display: flex;
      align-items: center;
      justify-content: center;
      margin-top: 10px;
    }
    &__thumbnailItem {
      padding: 6px;
      border: 1px solid #cccccc;
      &:first-child {
        margin-right: 4px;
      }
      &:last-child {
        margin-left: 4px;
      }

      &--active {
        border: 3px solid #E83532;
      }
    }
    &__thumbnailImage {
      width: 52px;
      height: 52px;
      object-fit: cover;
    }
  }
  .c-pageTitle {
    flex-wrap: wrap;

    &__label {
      padding: 4px 6px 6px;
      font-size: 12px;
    }
    &__name {
      width: 100%;
      margin-right: 0;
      text-align: left;
    }
  }
  .c-info {
    flex-wrap: wrap;

    &__content {
      width: 100%;
      margin-right: 0;
    }
    &__action {
      width: 100%;
      margin-top: 20px;
    }
    &__actionButtonWrap {
      display: block;

      .c-button {
        width: 100%;
        max-width: 320px;
        margin: 0 auto 10px;
      }
    }
    &__balloon {
      width: 100%;
      max-width: 320px;
      right: calc(50% - 160px);
      bottom: 44px;
    }
    &__item {
      margin-bottom: 8px;
    }
    &__smallItem {
      margin-right: 0;
      margin-bottom: 8px;
      width: 100%;
    }
    &__mobileButton {
      position: relative;
      display: block;
    }
    &__head {
      padding: 7px 10px;
      margin-right: 10px;
      width: 94px;
      border-radius: 4px;
      box-sizing: border-box;
    }
    &__data{
      width: calc(100% - 43%);
      &--big {
        font-size: 18px;
      }
    }
    &__date {
      margin-top: 12px;
      text-align: left;
    }
  }
  .c-table {
    &__head {
      width: 130px;
      line-height: 1.6;
    }
    &__data {
      width: calc(100% - 130px);
    }
  }
  .c-imageArea {
    display: none;
  }
  .c-section {
    max-width: 520px;
    margin: 30px auto 14px;

    &--detailInfo {
      margin: 25px auto 28px;
    }
  }
  .c-contentWrap {
    margin: 20px auto 0;
    max-width: 520px;
  }
  .c-imgList {
    &__item {
      width: calc(50% - 10px);
      max-width: 258px;
      margin-bottom: 10px;
    }
  }
}

@media screen and (max-width: 767px) {
  .uWhite {
    background-color: #FFF;
  }
  .c-button--balloon {
    left: calc(50% - 146px);
  }
  .c-imageArea {
    display: none;
  }
  .c-section {
    max-width: 100%;
    padding: 0 10px;
  }
  .c-contentSpWrap {
    padding: 0 10px;
  }
  .c-contentWrap {
    margin: 0 auto;
  }
  .c-imgList {
    padding: 0 10px;

    &__item {
      width: calc(50% - 5px);
      max-width: initial;

      &:nth-child(even) {
        margin-right: 0;
      }
    }
    &__img {
      height: 90px;
      object-fit: cover;
    }
  }
  .c-detailInfoTitle {
    font-weight: normal;
    text-align: left;
  }
  .c-detailInfoText {
    &__more {
      display: flex;
      align-items: center;
      justify-content: flex-end;
    }
    &__moreImg {
      width: 20px;
      height: 20px;
      margin-left: 10px;
      transform: rotate(90deg);
    }
  }
  .c-bannerFixed {
    padding: 12px 10px;
    text-align: left;
    line-height: 1.5;
  }
}

</style>
